// extracted by mini-css-extract-plugin
export default {"weekdaysList":"QjfY8lE9X3"};